<div class="container-fluid ">
  <div class="my-3" style="color: var(--default-font-color);cursor: pointer;width: fit-content;"  (click)="mainMenu()">
    <i class="fa-solid me-1 fa-arrow-left" style="color: var(--default-font-color);font-size: 15px;"></i>Back
  </div>
  <div class="row">
    <div class="col-md-6 chess-board-Box">
      <div class="d-flex justify-content-center align-items-center" style="flex-direction: column">
        <h3 class="text-center opening-heading">
          {{ openingTitle }}
          <span class="opening-eco">({{ openingEco }})</span>
        </h3>
        <div class="Main-chessBoard">
          <div #boardContainer id="hijk"></div>
          <canvas id="arrowCanvas"></canvas>
        </div>
      </div>
      <div>
        <p class="m-0 mt-2 px-2 text-center opening-heading">
          {{ openingMove }}
        </p>
      </div>
      <div class="d-flex justify-content-center p-2">
        <button class="btn move-button rounded" (keydown)="onKeyDown($event)" (click)="prevMove()">
          <i class="fa-solid fa-angle-left font-colors" style="color: var(--default-font-color)"></i>
        </button>
        <!-- <button class="btn ms-2 move-button rounded" (keydown)="onKeyDown($event)" (click)="nextMove()">
          <i class="fa-solid fa-angle-right font-colors" style="color: var(--default-font-color)"></i>
        </button> -->
        <button class="btn ms-2 move-button rounded" (keydown)="onKeyDown($event)" (click)="filpChessBoard()">
          <i class="fa-solid fa-repeat font-colors" style="color: var(--default-font-color)"></i>
        </button>
      </div>
    </div>

    <div class="col-md-6">

      @if(variationsData.length > 0 || variationsData == undefined) {
      <div class="table-variations">
        <table class="table table-striped mb-0">
          <thead class="table-head">
            <tr class="table-header table-header-sticky">
              <th scope="col">Variations</th>
              <th scope="col">Move</th>
            </tr>
          </thead>
          <tbody style="border-color: rgb(106 106 126)">
            @for (variations of variationsData; track $index) {
            @if(variations.gambit){
            <tr style="cursor: pointer" (click)="variationsSelectData(variations)">
              <td>{{ variations.gambit }}</td>
              <td>{{ variations.pgn }}</td>
            </tr>
            }@else if(variationsData.length <= 1) { <tr>
              <td colspan="2">
                <div class="d-flex justify-content-center">
                  <p class="text-white m-0">No Variations.</p>
                </div>
              </td>
              </tr>
              }
              }
          </tbody>
        </table>
      </div>
      }@else {
      <div class="table-leastOpening-responsive mt-3">
        <table class="table table-striped mb-0">
          <thead class="table-head">
            <tr class="table-header table-header-sticky">
              <th scope="col">Move</th>
              <th scope="col">Eco</th>
              <th scope="col">Opening/Variation</th>
            </tr>
          </thead>
          <tbody style="border-color: rgb(106 106 126)">
            @if(leastopeningMoveData?.length > 0){
            @for (newrecords of leastopeningMoveData; track $index) {
            <tr style="cursor: pointer">
              <td (mouseenter)="moveHoverData(newrecords)" [innerHTML]="newrecords.move | pieceIcon"
                (click)="tablepgn(newrecords)">
                {{ newrecords.move }}
              </td>
              <td>{{ newrecords.eco }}</td>
              <td>{{ newrecords.name }}</td>
            </tr>
            }
            }@else{
            <tr>
              <td colspan="6">
                <div class="d-flex justify-content-center">
                  <p class="text-white m-0">No game Record's.</p>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }


      <div class="table-responsive mt-3 mb-4" (scroll)="onScroll($event)">
        <table class="table table-striped mb-0">
          <thead class="table-head">
            <tr class="table-header table-header-sticky">
              <th scope="col">No.</th>
              <th scope="col">White</th>
              <th scope="col">Black</th>
              <th scope="col">Result</th>
            </tr>
          </thead>
          <tbody style="border-color: rgb(106 106 126)">
            @if(openingIDdata.length > 0){ 
            @for (records of openingIDdata; track
            $index) {
            <tr (click)="recondIddata(records._id)" style="cursor: pointer">
              <td>{{ $index + 1 }}</td>
              <td>{{ records.White }}</td>
              <td>{{ records.Black }}</td>
              <td>{{ records.Result }}</td>
            </tr>
            } 
          }@else{
            <tr>
              <td colspan="6">
                <div class="d-flex justify-content-center">
                  <p class="text-white m-0">No game Record's.</p>
                </div>
              </td>
            </tr>
            }
            @if(isLoading){
            <tr>
              <td colspan="6">
                <div class="d-flex justify-content-center">
                  <p class="loader ms-3 m-0"></p>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>